import LoginForm from '../../components/LoginForm/LoginForm';

const Login = () => {
  return <LoginForm />;
};
export default Login;
